/**
 * @format
 * @flow strict-local
 */
// DEPENDENCIES

import {
	Elements
} from "@stripe/react-stripe-js";
import {
	loadStripe
} from "@stripe/stripe-js";
import React, {
	useEffect,
	useState
} from "react";
import {
	connect
} from "react-redux";
import {
	useLocation,
	useNavigate
} from "react-router-dom";

import {
	BodyWrapper,
	ComponentWrapper,
	HeaderLogoWrapper,
	HeaderNavIconWrapper,
	HeaderWrapper
} from "./AppView.styled";

import Icon from "../../Icon";
import Logo from "../../Logo";

import routerHelper from "../../../helpers/router";
import storeHelper from "../../../helpers/store";

import useApi from "../../../hooks/api";

// INIT

/**
 * mapStateToProps - ...
 * 
 * @param {object} state ...
 */
const mapStateToProps = (state) => {
	return {
		...state
	};
};

// COMPONENT

const AppView = (props) => {
	/*
	const [
		isRenderReady, 
		setIsRenderReady
	] = useState(false);
	*/
	const [
		isSidebarOpen, 
		setIsSidebarOpen
	] = useState(false);

	const [
		stripePromise, 
		setStripePromise
	] = useState(null);

	const {
		fetchApi
	} = useApi();
	const location = useLocation();
	const navigate = useNavigate();

	// Lifecycle

	// Note - Run on bootstrap
	useEffect(
		() => {
			const waitAsync = async () => {
				let isValidAccessToken = true;

				if(props.LOCAL.user.accessToken) {
					const response = await fetchApi({
						method: "get",
						params: {
							app_version: "4.0.0", // Note - Need to bypass native app checkup
							device_id: "1", // Note - Need to bypass native app checkup
							service: "me"
						}
					});

					if(!response.error) {
						setStripePromise(
							loadStripe(response.payload.stripe_key)
						);

						storeHelper.dispatch(
							"SET_USER_NOTIFICATIONS", 
							{
								copped: response.payload.notifications.total_copped,
								listed: response.payload.notifications.total_listed,
								messages: response.payload.notifications.messages
							}
						);
						storeHelper.dispatch(
							"SET_USER_PROFILE", 
							{
								email: response.payload.email,
								firstName: response.payload.first_name,
								lastName: response.payload.last_name,
								phone: {
									countryCode: response.payload.phone_country_code,
									number: response.payload.phone
								}
							}
						);

						if(response.payload.saved_card) {
							storeHelper.dispatch(
								"SET_USER_SAVED_CARD", 
								{
									brand: response.payload.saved_card.type,
									last4: response.payload.saved_card.last4
								}
							);
						}
						/*
						storeHelper.dispatch(
							"SET_USER_SIZES", 
							{
								apparel: response.payload.sizes.apparel,
								footwear: response.payload.sizes.show
							}
						);
						*/
					} else {
						isValidAccessToken = false;
					}
				} else {
					isValidAccessToken = false;
				}

				if(!isValidAccessToken) {
					storeHelper.dispatch(
						"RESET_ALL"
					);

					const {
						pathname,
						search
					} = location;

					navigate({
						pathname: routerHelper.getUrl("signIn"),
						search: `?redirect=${encodeURIComponent(pathname + search)}`
					});

					return;
				}
			};

			waitAsync();
		}, 
		[]
	);

	// Events

	/**
	 * toggleSidebar - ...
	 * 
	 * @param {object} e ... 
	 */
	const toggleSidebar = (e) => {
		setIsSidebarOpen(!isSidebarOpen);
	};

	// Misc

	/**
	 * goTo - ...
	 * 
	 * @param {string} routeName ... 
	 */
	const goTo = (routeName) => {
		navigate({
			pathname: routerHelper.getUrl(routeName)
		});

		setIsSidebarOpen(false);
	};

	// Render

	/**
	 * render - ...
	 */
	const render = () => {
		let sidebarContent;

		if(isSidebarOpen) {
			/*
			<a
								onClick={(e) => goTo("dashboard")}
								>
								Dashboard
							</a>
			*/
			sidebarContent = (
				<div
						style={{
							backgroundColor: "#000",
							width: "240px",
							position: "fixed",
							top: 0,
							left: 0,
							bottom: 0,
							zIndex: 999
						}}
						>
						<div
							onClick={toggleSidebar}
							style={{
								backgroundColor: "#272727",
								padding: "16px",
								color: "#FFF",
								cursor: "pointer",
								textAlign: "right"
							}}
							>
							x
						</div>
						<div
							style={{
								padding: "16px",
								color: "#FFF",
								display: "flex",
								flexDirection: "column"
							}}
							>
							<a
								onClick={(e) => goTo("messages")}
								>
								Messages
							</a>
							<a
								onClick={(e) => goTo("cops")}
								>
								My Cops
							</a>
							<a
								onClick={(e) => goTo("lists")}
								>
								My Lists
							</a>
						</div>
					</div>
			);
		}

		return (
			<ComponentWrapper>
				<HeaderWrapper>
					<div>
						<HeaderNavIconWrapper
							onClick={toggleSidebar}
							>
							<Icon
								name="menu"
								noBoundingBox
							/>
						</HeaderNavIconWrapper>
					</div>
					<div>
						<HeaderLogoWrapper>
							<Logo
								name="copdate"
							/>
						</HeaderLogoWrapper>
					</div>
					<div>
					</div>
				</HeaderWrapper>
				<BodyWrapper>
					{sidebarContent}
					<Elements
						stripe={stripePromise}
						>
						{props.children}
					</Elements>
				</BodyWrapper>
			</ComponentWrapper>
		);  
	};

	return render();
};

// EXPORT

export default connect(mapStateToProps)(AppView);
